import { useState } from "react";
import { getConfigurationService, putConfigurationService } from "../../../utils";
import { getWorkServiceSelf } from "../actions/getAllServices.actions";
import { useSelector } from "react-redux";
import { groupServicesByType } from "../helpers/groupServicesByType";
import { patchSelectedServices } from "../actions/patchSelectedService";

export const useServiceConfiguration = () => {
  const token = sessionStorage.getItem("token");

  const [configuration, setConfiguration] = useState();
  const [loading, setLoading] = useState(false);
  const [services, setServices] = useState({ commercial: [], residential: [] });

  const { company } = useSelector((state) => state.userState);

  const getAllServices = async () => {
    setLoading(true);
    try {
      const data = await getWorkServiceSelf(token, company.id);

      const grouped = groupServicesByType(data);
      setServices(grouped);

      setLoading(false);
    } catch (error) {
      console.error("Error fetching all services:", error);
      setLoading(false);
      throw error;
    }
  };

  const updateSelectedServices = async (servicesMap) => {
    setLoading(true);
    try {
      const payload = {
        companyId: company.id,
        services: Object.entries(servicesMap).map(([id, isActive]) => ({
          id: Number(id),
          isActive,
        })),
      };

      const data = await patchSelectedServices(token, payload);
      if (data) {
        getAllServices()
      }

      return data

    } catch (error) {
      console.error("Error updating services", error);
    } finally {
      setLoading(false);
    }
  };



  const getServiceConfiguration = async (companyId, serviceId) => {
    setLoading(true);
    try {
      const { data } = await getConfigurationService(token, companyId, serviceId);
      setConfiguration(data.servicePrices);
    } catch (error) {
      console.error("Error fetching service configuration:", error);
    } finally {
      setLoading(false);
    }
  };

  const putServiceConfiguration = async (payload) => {
    setLoading(true);
    try {
      const data = await putConfigurationService(token, payload);
      console.log("Saved config:", data);
    } catch (error) {
      console.error("Error updating service configuration:", error);
    } finally {
      setLoading(false);
    }
  };

  return {
    // Actions
    getAllServices,
    updateSelectedServices,
    putServiceConfiguration,
    getServiceConfiguration,

    // State
    loading,
    configuration,
    services, // { commercial: [], residential: [] }
  };
};
